import React from "react";
import { RouteObject } from "react-router-dom";
import CategoryListingComponent from "../../categories/components/CategoryListingComponent";
import VerificationRequestComponent from "../components/VerificationRequestComponent";
import AdminLayout from "../AdminLayout";
import QuotesComponent from "../components/QuotesComponent";
import GeneralSettingComponent from "../components/GeneralSettingComponent";

const AdminRoutes: RouteObject[] = [
    {
        path: "/admin",
        element: <AdminLayout />,
        children: [

        ],
    },
];

export default AdminRoutes;